import React, { Component } from "react";
import "./Input.scss";
export default class InputState extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: true,
      text: this.props.value,
    };
  }
  handleChange = (val) => {
    this.setState({ text: val });
    this.props.onChange(val);
  };
  handleBlur = (bool) => {
    if (this.props.onBlur) {
      this.props.onBlur();
    }
    this.setState({ focused: bool });
  };
  onKeyUp = (key) => {
    if (this.props.onKeyUp) {
      this.props.onKeyUp(key);
    }
  };
  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ text: this.props.value });
    }
  }
  render() {
    const active = this.state.focused || this.props.value?.toString();
    return (
      <div
        styleName={
          active
            ? this.props.hollow
              ? this.props.error
                ? "base-hallow-err "
                : "base-hollow"
              : this.props.error
              ? "base-active-err"
              : "base-active"
            : this.props.hollow
            ? this.props.error
              ? "base-hallow-err "
              : "base-hollow"
            : this.props.error
            ? "base-err"
            : "base"
        }
        style={{ border: this.props.border, height: this.props.height }}
      >
        <div styleName={"content"}>
          <input
            id={this.props.id || this.props.placeholder}
            styleName="input-actual"
            value={this.state.text ? this.state.text : this.props.value}
            type={this.props.type}
            disabled={this.props.disabled}
            onBlur={() => this.handleBlur(false)}
            onFocus={() => this.setState({ focused: true })}
            onKeyUp={(event) => this.onKeyUp(event.key)}
            onChange={(event) => this.handleChange(event.target.value)}
            autoFocus={this.props.autoFocus}
            // autocomplete="on"
          ></input>
          <div styleName={active ? "placeholder-active" : "placeholder"}>
            <div
              styleName={
                this.props.disabled
                  ? "placeholder-disabled"
                  : "placeholder-text"
              }
              style={{ color: this.props.color }}
            >
              {this.props.placeholder}{" "}
              {this.props.required && <span styleName="required"> *</span>}
            </div>
          </div>
        </div>
        {this.props.error && (
          <div styleName={"errorMsg"}>{this.props.error}</div>
        )}
      </div>
    );
  }
}
